import { Store, useStore } from '../lib/store.ts';
import { db, type LocalProjectEntry } from './db.ts';

/** Projects known on this device, most recently opened first. */
export const registryStore = new Store<LocalProjectEntry[]>([]);
export const registryLoaded = new Store(false);

const sortEntries = (list: LocalProjectEntry[]) => [...list].sort((a, b) => b.openedAt - a.openedAt || b.updatedAt - a.updatedAt);

export async function loadRegistry() {
  const all = await (await db()).getAll('projects');
  registryStore.set(sortEntries(all));
  registryLoaded.set(true);
}

export function getRegistryEntry(id: string): LocalProjectEntry | undefined {
  return registryStore.get().find((p) => p.id === id);
}

export async function upsertRegistry(entry: LocalProjectEntry) {
  await (await db()).put('projects', entry);
  registryStore.set((list) => sortEntries([...list.filter((p) => p.id !== entry.id), entry]));
}

export async function patchRegistry(id: string, patch: Partial<LocalProjectEntry>) {
  const cur = getRegistryEntry(id) ?? (await (await db()).get('projects', id));
  if (!cur) return;
  const next = { ...cur, ...patch };
  const changed = (Object.keys(patch) as (keyof LocalProjectEntry)[]).some((k) => JSON.stringify(cur[k]) !== JSON.stringify(next[k]));
  if (!changed) return;
  await upsertRegistry(next);
}

export async function removeFromRegistry(id: string) {
  await (await db()).delete('projects', id);
  registryStore.set((list) => list.filter((p) => p.id !== id));
}

export const useLocalProjects = () => useStore(registryStore);
export const useRegistryLoaded = () => useStore(registryLoaded);
